<section class="pt-9">
  <div class="mask-curve-top relative bg-anis py-14 desk:py-20">
    <div class="centered-with-padding pb-6">
      <app-title [title]="data.title" size="h2" />
    </div>
    <div
      class="desk:centered-with-padding no-scrollbar flex gap-x-2.5 overflow-x-scroll px-5 desk:grid desk:grid-cols-2">
      @for (tuto of data.tutos; track $index) {
        <a [routerLink]="tuto.url" class="block h-[416px] w-11/12 shrink-0 desk:h-[398px] desk:w-full">
          <app-option-card [image]="tuto.image" [isPriority]="!isImageInPreviousBlocks && $index < 3">
            <div card-title-left class="mb-2.5">
              <app-title [title]="{ as: 'span', text: tuto.title }" size="normal"></app-title>
            </div>
            <div card-title-right class="mb-2.5">
              <app-svg [height]="17" [width]="23" src="assets/icons/arrow-right.svg" />
            </div>
            <div card-description>{{ tuto.description }}</div>
          </app-option-card>
        </a>
      }
    </div>
  </div>
</section>
